import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'IconRightArrow',
  props: {
    scale: { default: 1 }
  },
  setup(__props: any) {

const props = __props as { scale: number }



const width = computed<number>(() => {
    if (props.scale * 10 % 1 === 0) {
        return props.scale * 40;
    }
    return 40;
});

const height = computed<number>(() => {
    if (props.scale * 10 % 1 === 0) {
        return props.scale * 20;
    }
    return 20;
});


return { __sfc: true,props, width, height }
}

})